import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'pnk-card',
  styleUrl: 'pnk-card.css',
})
export class PnkCard {
  // deafult= purpose carde

  render() {
    return (
      <Host
        class="
          pnk-rounded-[10px]
          pnk-bg-white
          pnk-p-5
          pnk-w-inherit
          pnk-h-inherit
          pnk-min-h-[300px]
        "
      >
        <slot></slot>
      </Host>
    );
  }
}
